import { styled } from 'parkdepot-shared/theme'

export const TitleContainer = styled('div', ({ $theme }) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: $theme.sizing.scale700
}))

export const Text = styled('div', ({ $theme }) => ({
    ...$theme.typography.HeadingXSmall,
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)'
}))
